import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'select-template-associated-other-form',
  templateUrl: './select-template-associated-other-form.component.html',
  styleUrls: ['./select-template-associated-other-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectTemplateAssociatedOtherFormComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  forms = [];
  associationForm = new UntypedFormControl();
  filterForm = [];
  searchList;
  action_type_config_list = [];
  currentStep = 0;
  manageType = 'contact';
  searchText;
  noMatchFound;
  constructor(
    public dialogRef: MatDialogRef<SelectTemplateAssociatedOtherFormComponent>,
    private vaultService: VaultStoreEffects,
    private cd: ChangeDetectorRef,

    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
      })
    );
    let ids = [];

    this.currentStep = this.data.currentStep;
    this.action_type_config_list = this.data.action_type_config_list;
    this.data.action_type_config_list.forEach((element, index) => {
      if (this.forms.findIndex((x) => x.type == this.data.action_type_config_list[index].description) != -1) {
        let current_template = this.forms.find((x) => x.type == this.data.action_type_config_list[index].description);
        ids.push(current_template.id);
      }
    });
    if (this.data?.manageType) {
      this.manageType = this.data?.manageType;
    }

    if (this.data?.templateList?.length) {
      this.data?.templateList.forEach((element) => {
        let findIndex = this.forms.findIndex((x) => x.type?.toLowerCase().indexOf(element.toLowerCase()) >= 0);
        if (findIndex >= 0) {
          this.filterForm.push({
            selected: false,
            ...this.forms[findIndex],
          });
        }
      });
    } else {
      this.forms.forEach((element) => {
        try {
          if (ids.findIndex((x) => x == element.id) == -1 && element?.type_template?.toLowerCase().indexOf(this.manageType.toLowerCase()) >= 0) {
            this.filterForm.push({
              selected: false,
              ...element,
            });
          }
        } catch (error) {
          console.error('error in type_template is field');
        }
      });
    }
    this.subscription.add(
      this.associationForm.valueChanges
        .pipe(
          startWith(''),
          map((value) => this.filter(value))
        )
        .subscribe((response) => {
          if (response.length == 0 && this.searchText) {
            this.noMatchFound = true;
          } else {
            this.noMatchFound = false;
          }
          this.searchList = response;
          this.cd.detectChanges();
        })
    );
  }

  private filter(value) {
    let searchList = this.filterForm;
    if (searchList && value?.toLowerCase().length && value.length != 0) {
      this.searchText = true;
      return searchList.filter((user) => user?.type?.toLowerCase().includes(value?.toLowerCase()));
    } else {
      this.searchText = false;
      return searchList;
    }
  }
  handleFolderSelected(item, index) {
    this.dialogRef.close({
      success: true,
      id: item.id,
    });
  }

  closeDialog() {
    this.dialogRef.close({
      success: false,
    });
  }
}
